/*
 * @Author: wp
 * @Date: 2023-01-04 17:18:52
 * @Descripttion:
 */

import createPersistedState from 'vuex-persistedstate'

/**
 * 模块里面所需常驻的参数
 */

const paths = {
    ry: ['token', 'userId', 'imSingleChat'],
    game: ['goodsTypeCateList', 'gameList', 'goodsKey', 'gameHotList', 'releaseDataObj', 'releaseGoodsBreadcrumb', 'goodsSearchRang', 'buyGoodsTyp', 'payInfo', 'categoryList', 'releaseGoodsCatalogueId'],
    tracking: ['pointList'],
    bargain: ['bargainSellerGoodsInfo']
}

const indexModule = ['bargainingState', 'messageReceiptState', 'editGoodsState', 'operatingSystem', 'wbxdId',]

export default ({ store }) => {
    const newPaths = Object.entries(paths).flatMap(([key, values]) => values.map(value => `${key}.${value}`))
    createPersistedState({
        paths: ['user', ...indexModule, ...newPaths],
        storage: localStorage
    })(store)
}
